import { Volume2, VolumeX } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useRoomController, useRoomState } from "../../room/RoomContext";
import { Button } from "../ui/button";
import { PositionedContextMenu } from "../ui/context-menu";
import { ContextMenuLabel, ContextMenuSeparator } from "../ui/context-menu";
import { MenuDescription } from "../ui/dropdown-menu";
import { Field } from "../ui/field";
import { Slider } from "../ui/slider";

export function StreamContextMenu() {
  const { t } = useTranslation();
  const controller = useRoomController();
  const point = useRoomState((s) => s.participants.contextMenu);
  const name = useRoomState((s) => s.participants.contextName);
  const muted = useRoomState((s) => s.participants.contextMuted);
  const volume = useRoomState((s) => s.participants.contextVolume);
  const disabled = useRoomState((s) => s.participants.contextDisabled);
  const reason = useRoomState((s) => s.participants.contextUnavailableReason);
  if (!point) return null;
  const label = t(muted ? "voice.unmuteParticipant" : "voice.muteParticipant");
  const VolumeIcon = muted ? VolumeX : Volume2;
  return (
    <PositionedContextMenu
      key={`${point.peerId}:${point.x}:${point.y}`}
      point={point}
      onClose={controller.closeStreamContextMenu}
      id="streamContextMenu"
      // It holds a button and a slider, not menu items: expose it as a labelled
      // popup dialog instead of Radix's default menu role.
      role="dialog"
      aria-orientation={undefined}
      aria-label={t("voice.participantAudioControls")}
    >
      <ContextMenuLabel>
        <span className="block truncate">{name}</span>
        <MenuDescription>{t("common.microphone")}</MenuDescription>
      </ContextMenuLabel>
      <ContextMenuSeparator />
      <ContextMenuLabel>
        <Field orientation="horizontal">
          <Button
            id="contextMute"
            variant="ghost"
            size="icon-sm"
            disabled={disabled}
            aria-label={label}
            title={
              reason === "voices"
                ? t("voice.unmuteOtherVoices")
                : reason === "microphone"
                  ? t("voice.participantMicrophoneUnavailable")
                  : label
            }
            onClick={controller.toggleContextMute}
          >
            <VolumeIcon aria-hidden="true" />
          </Button>
          <span id="contextVolumeLabel" className="sr-only">
            {t("voice.participantVolume")}
          </span>
          <Slider
            id="contextVolume"
            min={0}
            max={100}
            step={1}
            value={[volume]}
            disabled={disabled}
            aria-labelledby="contextVolumeLabel"
            onValueChange={([value]) => controller.setContextVolume(value)}
          />
        </Field>
      </ContextMenuLabel>
    </PositionedContextMenu>
  );
}
